export { default as Heading } from './heading'
